"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { DataBuilderComponentsContext } from './use-data-builder-components.mjs';

function DataBuilderComponentsProvider({
  children,
  Nested,
  FieldValue,
  DataBuilderFormField
}) {
  const value = useMemo(
    () => ({ Nested, FieldValue, DataBuilderFormField }),
    [Nested, FieldValue, DataBuilderFormField]
  );
  return /* @__PURE__ */ jsx(DataBuilderComponentsContext.Provider, { value, children });
}

export { DataBuilderComponentsProvider };
